// extracted by mini-css-extract-plugin
module.exports = {"content":"settings_content__2xQ67","switchcontainer":"settings_switchcontainer__16JE7"};